import React, { Component } from "react";
import MainLayout from '../../mainLayout';

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

//Loader import
import Loader from "../loader";

//Service import
import service from '../../services'

//Validation import
import SimpleReactValidator from 'simple-react-validator';

//moment import
import moment from 'moment'

//Redux Connect
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ActCreators } from '../../redux/bindActionCretor'

//react-paginate import
import ReactPaginate from "react-paginate";

//sweet alert
import swal from 'sweetalert';

// Images import
import serachIcon from "../../assets/images/search.svg";
import edit from "../../assets/images/edit.svg";
import delet from "../../assets/images/delet.svg";
import closeIcon from "../../assets/images/close-black.svg";
import { Link } from "react-router-dom";
import FilterActiveIcon from "../../icons/filteractiveicon";
import FilterIcon from "../../icons/filtericon";

let sub;
// fake data generator
const getItems = count =>
  Array.from({ length: count }, (v, k) => k).map(k => ({
    id: `item-${k}`,
    content: `item ${k}`
  })
  );

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const mapStateToProps = state => ({
  getLoginRole: state.getLoginRole,
  getLoginAdminByID: state.getLoginAdminByID,
})

const mapDispatchToProps = dispatch => {
  return bindActionCreators(ActCreators, dispatch)
};

let displayTemplateWiseData = [];
let statusFilterList = []
class ArtistListView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      createEventUserPopup: false,
      getAllEventDetails: getItems(0),
      getAllPartnerDetails: [],
      totalDocs: '',
      searchField: '',
      // pagination variable diclaration start
      offset: 0,
      perPage: 50,
      currentPage: 1,
      // pagination variable diclaration end
      loaderFlag: false,
      isDraggable: false,
      displayTemplateArray: [
        { name: "All TemplateType", value: true },
        { name: "General", value: false },
        { name: "Screening", value: false },
        { name: "Panel", value: false },
        { name: "Offer", value: false },
      ],
      statusArray:[
        {assign:"Live", list:1, value:false},
        {assign:"Disable", list:2, value:false},
    ],
    };
    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    this.apiserve = new service();
    this.onDragEnd = this.onDragEnd.bind(this);
  }

  componentDidMount = () => {
    this.props.GetPartnerEvent('')
    this.getAllEvent();

    this.getAllPartnerView()
    this.getPartner()

    let currentPage = localStorage.getItem('currentPage')
    if (currentPage) {
      this.setState(
        {
          offset: parseInt(localStorage.getItem("offset")),
          perPage: parseInt(localStorage.getItem("perPage")),
          currentPage: parseInt(localStorage.getItem("currentPage")),
        },
        () =>
          this.getAllEventView(this.state.offset, this.state.perPage)
      );
      localStorage.removeItem("offset");
      localStorage.removeItem("perPage");
      localStorage.removeItem("currentPage");
    } else {
      this.setState({
        offset: 0,
        perPage: 50,
        currentPage: 0
      })
      this.getAllEventView(this.state.offset, this.state.perPage)
    }
  }

  componentWillUnmount = () => {
    sub.unsubscribe();
    displayTemplateWiseData = [];
    statusFilterList = []
  }

  getAllEvent = () => {
    sub = this.apiserve.getevent().subscribe((response) => {
      switch (response.event) {
        case "FestivalVillage|ArtistLounge|getArtistEventCms":
          this.setState({
            getAllEventDetails: response.data.docs,
            totalDocs: response.data.totalDocs,
            pageCount: Math.ceil(response.data.totalDocs / this.state.perPage),
          }, () => {
            this.setState({ loaderFlag: false })
          })
          break;
        case "FestivalVillage|ArtistLounge|deleteEvent":
          this.getAllEventView(this.state.offset, this.state.perPage)
          break;
        case "updateEvent":
          this.getAllFillter(this.state.offset, this.state.perPage);
          this.setState({ loaderFlag: false });
          // this.apiserve.success('Partner Event updated successful.');
          break;
        case "getUser":
          this.setState({
            getPerticularPartner: response.data.partnerName
          })
          break;
        case "getAllPartner":
          response.data.docs.forEach(doc => doc.value = false)
          this.setState({
            getAllPartnerDetails: [{ partnerName: 'All', value: true }, ...response.data.docs],
          }, () => {
            this.setState({ loaderFlag: false })
          })
          break;
      }
    });
  }

  getAllEventView = (skip, limit) => {
    var data = {
      page: skip,
      limit: limit,
    }
    if (this.state.searchField.length) {
      data.filter = this.state.searchField
    }
    if (displayTemplateWiseData && displayTemplateWiseData.length) {
      data.eventDisplayTemplate = displayTemplateWiseData
    }
    if (statusFilterList && statusFilterList.length) {
      data.status = statusFilterList
    }

    this.apiserve.sendevent("FestivalVillage|ArtistLounge|getArtistEventCms", data);
    this.setState({ loaderFlag: true })
  }

  getAllPartnerView = () => {
    const { getLoginRole } = this.props
    if (getLoginRole.user.role === 'admin') {
      var data = {
        role: "partner",
        limit: '50'
      }
    } else {
      var data = {
        role: "partner",
        addedBy: getLoginRole.user._id,
        limit: '50'
      }
    }

    this.apiserve.sendevent("getAllPartner", data);
  }

  onDragEnd(result) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    this.setState({ isDraggable: true });
    const items = reorder(
      this.state.getAllEventDetails,
      result.source.index,
      result.destination.index
    );

    for (let i = 0; i < items.length; i++) {
      let data = {
        "id": items[i]._id,
        "showIndex": i + 1
      };
      this.apiserve.sendevent("updateEvent", data);
    }

    this.setState({
      items
    });


  }

  editEvent = (item) => {
    this.props.GetPartnerEvent(item)
    localStorage.setItem('currentPage', this.state.currentPage)
    localStorage.setItem('perPage', this.state.perPage)
    localStorage.setItem('offset', this.state.offset)
    this.props.history.push('/artist-event-view')
  }

  deleteEvent = (item) => {
    swal({
      title: "Are you sure?",
      text: "You want to delete this record",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
      .then((willDelete) => {
        if (willDelete) {
          swal("Your record has been deleted!", {
            icon: "success"
          });
          this.apiserve.sendevent("FestivalVillage|ArtistLounge|deleteEvent", {
            id: item._id
          });
        } else {
          swal("Your record is safe!");
        }
      });
  }

  //displayTemplateWiseFilter Wise Filter start
  displayTemplateWiseFilter = (e, selectedInex) => {
    let index = selectedInex
    let event = e.target.checked
    let displayTemplateList = [...this.state.displayTemplateArray]
    displayTemplateList.forEach((key, i) => {
      if (index === 0) {
        if (i === 0) {
          displayTemplateList[index].value = event
        } else {
          displayTemplateList[i].value = false
        }
      } else {
        if (i === 0) {
          if (displayTemplateWiseData && displayTemplateWiseData.length === 1 && !event) {
            displayTemplateList[i].value = true
          } else {
            displayTemplateList[i].value = false
          }
        } else {
          displayTemplateList[index].value = event
        }
      }

    });
    this.setState({
      ...this.state,
      displayTemplateArray: displayTemplateList
    }, () => {
      if (index === 0 && event) {
        displayTemplateWiseData = []
      } else if (event) {
        displayTemplateWiseData = [...displayTemplateWiseData, this.state.displayTemplateArray[index].name];
      } else {
        let tempArray = displayTemplateWiseData.filter((d) => d !== this.state.displayTemplateArray[index].name);
        displayTemplateWiseData = tempArray;
      }
      this.getAllFillter(this.state.offset, this.state.perPage);
    })
  };
  //displayTemplateWiseFilter Wise Filter end


  getAllFillter = (skip, limit) => {
    this.setState({ loaderFlag: true })
    var data = {
      page: skip,
      limit: limit,
    }
    if (this.state.searchField.length) {
      data.filter = this.state.searchField
    }
    if (displayTemplateWiseData && displayTemplateWiseData.length) {
      data.eventDisplayTemplate = displayTemplateWiseData
    }
    if (statusFilterList && statusFilterList.length) {
      data.status = statusFilterList
    }
    this.apiserve.sendevent("FestivalVillage|ArtistLounge|getArtistEventCms", data);
  }

  //Search Data
  onSearchFilter = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    }, () => {
      var data = {
        page: 1,
        limit: 50,
      }
      if (this.state.searchField.length) {
        data.filter = this.state.searchField
      }
      if(displayTemplateWiseData && displayTemplateWiseData.length){
        data.eventDisplayTemplate = displayTemplateWiseData
      }
      if (statusFilterList && statusFilterList.length) {
        data.status = statusFilterList
      }
      this.apiserve.sendevent("FestivalVillage|ArtistLounge|getArtistEventCms", data);
    });
  }

  //Pagination Click
  handlePageClick = (e) => {
    const selectedPage = e.selected;
    const offset = selectedPage + 1;
    this.setState(
      {
        currentPage: selectedPage,
        offset: offset,
        loaderFlag: true
      },
      () => {
        this.getAllEventView(offset, this.state.perPage);
      }
    );
  };

  
  StatusFilter = (e, selectedInex,isClearStatusType = false) => {
    let index = selectedInex
    let event = e && e.target && e.target.checked
    let approvePassList = [...this.state.statusArray]
    approvePassList.forEach((key, i) => {
    if(i === index) {
        approvePassList[i].value = event
    }
    if(isClearStatusType) {
        approvePassList[i].value = false
        statusFilterList=[]
    }
    
    })
    this.setState({
        ...this.state,
        statusArray: approvePassList,
        currentPage:0
    },()=> {
        if (event) {
            if (index !== null) {
                statusFilterList = [...statusFilterList, this.state.statusArray[index].list];
            }         
            
    } else {
        if (index !== null) {
            let tempArray = statusFilterList.filter((d) => d !== this.state.statusArray[index].list);
            statusFilterList = tempArray; 
        }
    }
    this.getAllFillter(this.state.offset, this.state.perPage,isClearStatusType.isClearProgramType);
    })
}

  eventTableHead = () => {
    const { getLoginRole } = this.props
    let { getAllPartnerDetails, displayTemplateArray } = this.state
    let getAllPartner = getAllPartnerDetails.reduce((unique, o) => {
      if (!unique.some(obj => obj._id === o._id)) {
        unique.push(o);
      }
      return unique;
    }, []);
    return (
      <thead>
        <tr>
          <th className="PAV_eventName" style={{width:"250px"}}>Event Name</th>
          <th className="eventDate_block" style={{width:"330px"}}>
            <div className="event_block">
              <div className="PAV_eventDate">Event Date</div>
              <div className="PAV_eventTime">Event Time (MT)</div>
            </div>
          </th>
          <th className="PAV_displayTemp depart_d" >
            <span className="d_flex d_flex_align_center">
              Display Format
                      {/* <img src={hoverIcon} className="dot_img" />
                          <img src={hoverIconActive} className="dot_hover_img"/> */}
              {displayTemplateWiseData && displayTemplateWiseData.length ?
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style={{margin:"0 11px"}}>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M6 12.5C6 12.3674 6.05268 12.2402 6.14645 12.1464C6.24021 12.0527 6.36739 12 6.5 12H9.5C9.63261 12 9.75979 12.0527 9.85355 12.1464C9.94732 12.2402 10 12.3674 10 12.5C10 12.6326 9.94732 12.7598 9.85355 12.8536C9.75979 12.9473 9.63261 13 9.5 13H6.5C6.36739 13 6.24021 12.9473 6.14645 12.8536C6.05268 12.7598 6 12.6326 6 12.5ZM4 9.5C4 9.36739 4.05268 9.24021 4.14645 9.14645C4.24021 9.05268 4.36739 9 4.5 9H11.5C11.6326 9 11.7598 9.05268 11.8536 9.14645C11.9473 9.24021 12 9.36739 12 9.5C12 9.63261 11.9473 9.75979 11.8536 9.85355C11.7598 9.94732 11.6326 10 11.5 10H4.5C4.36739 10 4.24021 9.94732 4.14645 9.85355C4.05268 9.75979 4 9.63261 4 9.5ZM2 6.5C2 6.36739 2.05268 6.24021 2.14645 6.14645C2.24021 6.05268 2.36739 6 2.5 6H13.5C13.6326 6 13.7598 6.05268 13.8536 6.14645C13.9473 6.24021 14 6.36739 14 6.5C14 6.63261 13.9473 6.75979 13.8536 6.85355C13.7598 6.94732 13.6326 7 13.5 7H2.5C2.36739 7 2.24021 6.94732 2.14645 6.85355C2.05268 6.75979 2 6.63261 2 6.5Z" fill="black" />
                  <circle cx="8" cy="2" r="2" fill="black" />
                </svg>
                :
                <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg" style={{margin:"0 11px"}}>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M4 6.5C4 6.36739 4.05268 6.24021 4.14645 6.14645C4.24021 6.05268 4.36739 6 4.5 6H7.5C7.63261 6 7.75979 6.05268 7.85355 6.14645C7.94732 6.24021 8 6.36739 8 6.5C8 6.63261 7.94732 6.75979 7.85355 6.85355C7.75979 6.94732 7.63261 7 7.5 7H4.5C4.36739 7 4.24021 6.94732 4.14645 6.85355C4.05268 6.75979 4 6.63261 4 6.5ZM2 3.5C2 3.36739 2.05268 3.24021 2.14645 3.14645C2.24021 3.05268 2.36739 3 2.5 3H9.5C9.63261 3 9.75979 3.05268 9.85355 3.14645C9.94732 3.24021 10 3.36739 10 3.5C10 3.63261 9.94732 3.75979 9.85355 3.85355C9.75979 3.94732 9.63261 4 9.5 4H2.5C2.36739 4 2.24021 3.94732 2.14645 3.85355C2.05268 3.75979 2 3.63261 2 3.5ZM0 0.5C0 0.367392 0.0526785 0.240215 0.146447 0.146447C0.240215 0.0526785 0.367392 0 0.5 0H11.5C11.6326 0 11.7598 0.0526785 11.8536 0.146447C11.9473 0.240215 12 0.367392 12 0.5C12 0.632608 11.9473 0.759785 11.8536 0.853553C11.7598 0.947321 11.6326 1 11.5 1H0.5C0.367392 1 0.240215 0.947321 0.146447 0.853553C0.0526785 0.759785 0 0.632608 0 0.5Z" fill="black" />
                </svg>
              }
            </span>
            <div className="tabelData_popup" style={{left:"0px"}}>
              <form>
                <div className="customCheck">
                  {displayTemplateArray.map((item, i) => (
                    <div className="customCheckBox">
                      <input
                        type="checkbox"
                        id={item.name}
                        name={item.name === 'All TemplateType' ? 'All' : item.name}
                        value={item.value ? true : false}
                        checked={item.value ? true : false}
                        onClick={(e) => this.displayTemplateWiseFilter(e, i)}
                      />
                      <label htmlFor={item.name}>{item.name === 'All TemplateType' ? 'All' : item.name}</label>
                    </div>
                  ))}

                </div>
              </form>
            </div>
          </th>
          <th className="PAV_updateOn" style={{width:"150px"}}>Updated On</th>
          <th className="PAV_updateBy" style={{width:"150px"}}>Added On</th>
          <th className="depart_d"> 
              <span className="disp_flex d_flex_align_center">Status 
              {statusFilterList && statusFilterList.length ?
                  <FilterActiveIcon /> 
                  :
                  <FilterIcon /> 
              }
              </span> 
              <div className="tabelData_popup" style={{minHeight:"130px"}}>
                      <form>
                          <div className="customCheck">
                              <div className="customCheckBox clear_all_popup d_flex d_flex_justify_spacebt">
                                  <p className="link" onClick={()=>this.StatusFilter(null,null,true,null)}>Clear All</p>
                              </div>
                              
                              <div className="customCheckBox">
                              {this.state.statusArray.map((item,i)=>(
                                  <div className="customCheckBox">
                                  <input
                                      type="checkbox"
                                      id={'status'+item.list}
                                      name={'status'+item.list}
                                      value={item.list ? true : false}
                                      checked={item.value ? true : false}
                                      onClick={(e) => this.StatusFilter(e, i)}
                                  />
                                  <label htmlFor={'status'+item.list}>{item.assign}</label>
                                  </div>
                                  ))
                              }
                              </div>
                              </div>
                      </form>
                  </div>   
          </th>
        </tr>
      </thead>
    )
  }

  eventTableBody = () => {
    const { getAllEventDetails, updateOn } = this.state
    const { getLoginRole } = this.props
    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <Droppable droppableId="droppable">
          {(provided, snapshot) => (
            <tbody
              {...provided.droppableProps}
              ref={provided.innerRef}>
              {getAllEventDetails.map((item, index) => (
                <Draggable
                  key={item._id}
                  draggableId={item._id}
                  index={index}
                  isDragDisabled={true}>
                  {(provided, snapshot) => (
                    <tr
                    onClick={() => this.editEvent(item)}
                    className={`pointer ${ item.status === 2 ? 'disable' : ''}`}
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}>
                      <td className="PAV_eventName">{item.eventDisplayTemplate === "Offer" ? item.offerTitle: item.eventTitle}</td>
                      <td className="eventDate_block">
                        <div className="event_block">
                          {item && item.eventDate[0] && item.eventDate[0].dateKey ?
                            <p>{item && item.eventDate[0] && item.eventDate[0].dateKey}</p>
                            :
                            item.eventDisplayTemplate === "Offer" ? 
                            <p>All Festival</p>
                            :
                            <>
                              <div className="PAV_eventDate">
                                {item.eventDate.map((dateItem) => {
                                  return (<span>{moment.tz(dateItem.date, "US/Mountain").format('MM/DD/YYYY')}</span>)
                                })}
                              </div>
                              <div className="PAV_eventTime">
                                <span>
                                  {item.eventDate.map((timeItem) => {
                                    return timeItem.eventParticularTime.map((anotherTime) => {
                                      return <p>
                                        {moment(anotherTime.start).tz("US/Mountain").format('h')}:{moment(anotherTime.start).tz("US/Mountain").format('mm')} {moment(anotherTime.start).tz("US/Mountain").format('A')}
                                        - {moment(anotherTime.end).tz("US/Mountain").format('h')}:{moment(anotherTime.end).tz("US/Mountain").format('mm')} {moment(anotherTime.end).tz("US/Mountain").format('A')}</p>
                                    });
                                  })}
                                </span>
                              </div>
                            </>
                          }
                        </div>
                      </td>
                      <td className="PAV_displayTemp">{item.eventDisplayTemplate}</td>
                      <td className="PAV_updateOn">{moment(item.updatedAt).format('MM/DD/YYYY')}</td>
                      <td className="PAV_updateOn">{moment(item.updatedAt).format('MM/DD/YYYY')}</td>
                      {/* <td className="icon_d"> */}
                        {/* <Link onClick={() => this.editEvent(item)} to='/artist-event-view'>
                          <img src={edit} /><div>edit</div>
                        </Link>
                        <Link onClick={() => this.deleteEvent(item)}>
                          <img src={delet} /><div>delete</div>
                        </Link> */}  
                        <td style={{width:"90px"}}>
                            <div>
                                <p>{item.status === 1 ? 'Live' : item.status === 2 ? 'Disabled' : ''}</p>
                            </div>
                      </td> 
                      {/* </td> */}
                    </tr>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </tbody>
          )}
        </Droppable>
      </DragDropContext>
    )
  }

  getPartner = () => {
    const { getLoginRole } = this.props
    this.apiserve.sendevent("getUser", {
      id: getLoginRole.user._id
    });
  }

  render() {
    const { getAllEventDetails, totalDocs, getPerticularPartner } = this.state;
    const { getLoginRole } = this.props
    return (
      <React.Fragment>
        <div className={`right_side_wrapper partnerAdminView_wrapper ${getLoginRole.user.role === "partner" ? "partner_view_wrapper" : ""}`}>
          <div className="dashboard_header with_btn">
            <div className="searchBlock">
              <span>
                {getLoginRole.user.role === 'partner' ? getPerticularPartner + ' > ' : ''}
                                Artist Lounge Events ( {totalDocs} )
                            </span>
              <form onSubmit={e => { e.preventDefault(); }}>
                <input
                  type="text"
                  placeholder="Search"
                  id="searchField"
                  name="searchField"
                  value={this.state.searchField}
                  onChange={this.onSearchFilter}
                />
                <button type="submit" style={{ pointerEvents: 'none' }}>
                  <img src={serachIcon} />
                </button>
              </form>
            </div>
            <div className="button_block d_flex">
              <Link to='/artist-event-view' className="head_btn">Create Event</Link>
            </div>
          </div>
          <div className="dashboard_data">
            <table>
              {this.eventTableHead()}
              {this.eventTableBody()}
            </table>
          </div>
          {/* Pagination View Display */}

          {getAllEventDetails.length && getAllEventDetails ? (
            <div className="custom-pagination">
              <ReactPaginate
                previousLabel={""}
                nextLabel={""}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={this.state.pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={this.handlePageClick}
                containerClassName={"pagination"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
                forcePage={this.state.currentPage}
              />
            </div>
          ) : (
              ""
            )}
        </div>


        {/* Loader */}
        {this.state.loaderFlag ? (
          <Loader />
        ) : (
            ""
          )}

      </React.Fragment>
    )
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(ArtistListView)
